const ResetModal = function () {
  this.addUser.hideModal()
  this.addUser.resetForm()
}

export default ResetModal
